import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/less/main.less';
import App from './pages';

ReactDOM.render(<App />, document.getElementById('root'));
